import React from 'react'
import {PageSectionTitle} from "../commons";
import {EconomicCard} from "./economic-card/economic-card";
import {EconomicCardsData} from "./economic-card/models";
import {Grid} from "@mui/material";


interface CommissionsProps {

}

interface  CommissionsState {

}

export class Commissions extends React.Component<CommissionsProps, CommissionsState>
{
    render(){
        return (
            <>
                <PageSectionTitle title={"Commissioni"} />
                <Grid container spacing={3} sx={{mt: 1}}>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard cardType={EconomicCardsData.COMMISSIONS_CASHIN} value={0.00} />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard cardType={EconomicCardsData.AVERAGE_COMMISSIONS_CASHIN} value={0.00} />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard cardType={EconomicCardsData.COMMISSIONS_PAID} value={0.00} />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <EconomicCard cardType={EconomicCardsData.AVERAGE_COMMISSIONS_PAID} value={0.00} />
                    </Grid>
                </Grid>


            </>
        )
    }
}
